import { PercentPipe } from '@angular/common';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'optionalPercent',
})
export class OptionalPercentPipe extends PercentPipe {
  transform(value: number, digits?: string): string | null {
    if (isNaN(value) === false && isFinite(value)) {
      return super.transform(value, digits);
    }
    return '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/optionalPercent.pipe.ts